class CustomCursorController {
  constructor() {
    this.$body = $('body');
    this.$className = 'custom-cursor';
    this.$element = $(`.${this.$className}`).eq(0);
    this.$items = this.$element.find(`.${this.$className}__item`);
    this.$positionX = 0;
    this.$positionY = 0;
    this.$target = null;

    this.$addEventListeners();
    this.$addMouseLeaveInterval();
    this.$addRequestAnimationHandler();
  }

  $addEventListeners() {
    this.$body.on('mousemove',  this.$onMouseMove);
    this.$body.on('mouseenter', `.${this.$className}__subscriber`, this.$onMouseEnter);
    this.$body.on('mouseleave', `.${this.$className}__subscriber`, this.$onMouseLeave)
  }

  $addRequestAnimationHandler() {
    window.requestAnimationFrame(() => {
      this.$updateElementStyle();
      this.$addRequestAnimationHandler();
    });
  }

  // Быстрое и топорное решение проблемы с несрабатыванием события mouseleave при прокрутке.
  // Так и не понял причину пробуксовки, воспроизводилось только со слайдерами.
  // Возможно slick в каких-то случиях рубит события.
  $addMouseLeaveInterval() {
    window.setInterval(() => {
      if (this.$target && !this.$target.matches(':hover')) {
        this.$onMouseLeave();
      }
    }, 500);
  }

  $onMouseEnter = (event) => {
    // На всякий случай пропускаем вперёд mouseleave
    window.setTimeout(() => {
      this.$element.addClass(`${this.$className}--visible`);
      this.$target = event.currentTarget;

      const activeType = this.$target.dataset.cursor;
      this.$updateActiveItem(activeType);
    }, 0);
  }

  $onMouseLeave = () => {
    this.$element.removeClass(`${this.$className}--visible`);
    this.$resetActiveItem();
    this.$target = null;
  }

  $onMouseMove = (event) => {
    this.$positionX = event.clientX;
    this.$positionY = event.clientY;
  }

  $resetActiveItem() {
    const instance = this;

    this.$items.each(function() {
      const $item = $(this);
      $item.removeClass(`${instance.$className}__item--active`);
    });
  }

  $updateActiveItem(type = 'default') {
    const instance = this;

    this.$items.each(function() {
      const $item = $(this);
      $item.toggleClass(`${instance.$className}__item--active`, $item.data('type') === type);
    });
  }

  $updateElementStyle() {
    this.$element.css({
      left: this.$positionX + 'px',
      top: this.$positionY + 'px'
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CustomCursorController();
});